<script setup lang="ts">
import type {ArticleAsset} from '@/types';
import {HomeFeature, HomeFeatureTile, HomeFeatureContent, HomeFeatureContentLogo, HomeFeatureContentBody} from '@/lib/ui/home-feature';

const {translate} = useTranslation();
const data = ref();

if (import.meta.client) {
  const {data: lazyResp, error} = await useLazyFetch<ArticleAsset>(`/api/asset-by-slug?slug=ever-home-feature&status=${window ? (window.location !== window.parent.location ? 'draft' : 'published') : 'published'}`, {server: false});

  if (lazyResp.value && !error) {
    data.value = lazyResp.value as ArticleAsset;
  }

  watch(lazyResp, () => {
    data.value = lazyResp.value as ArticleAsset;
  });
}
</script>

<template>
  <template v-if="data">
    <HomeFeature class="bg-[var(--ever-color-lighter)] reverse-on-mobile">
      <HomeFeatureContent class="bg-[url('/assets/ever/ever-feature-content-bground.png')] bg-center bg-cover">
        <HomeFeatureContentLogo>
          <img :src="data.fields.feature_icon.public_url" alt="Ever Logo" />
        </HomeFeatureContentLogo>

        <HomeFeatureContentBody>
          <h3 class="text-white" v-html="translate(data.fields.sub_title)" />

          <div class="text-white flex flex-col gap-[3rem]" v-html="translate(data.fields.content)" />

          <ul class="flex gap-[1.5rem]">
            <li>
              <TheButton tag="NuxtLink" class="!border-none !bg-[var(--ever-color)] !py-4 hover:!bg-black hover:!text-white" :to="data.fields.cta_2_url.value" aria-label="Learn more about Ever">Reserve your date</TheButton>
            </li>
          </ul>

          <p class="text-white">
            <small>
              Have questions about how to celebrate with us?
              <br />
              Connect with our concierge at
              <NuxtLink to="mailto:Ever@OneTimesSquare.com" class="underline">Ever@OneTimesSquare.com</NuxtLink>
            </small>
          </p>
        </HomeFeatureContentBody>
      </HomeFeatureContent>

      <HomeFeatureTile>
        <img :src="data.fields.feature_image.public_url" alt="EVER Feature" />

        <img v-gsap.whenVisible.once.reversible.from="{opacity: 0, y: '20%'}" :src="data.fields.feature_icon.public_url" alt="Ever Logo" class="mobile-only" />
      </HomeFeatureTile>
    </HomeFeature>
  </template>
</template>
